import React, {Component} from 'react';

import 'rc-steps/assets/index.css';
import Steps, { Step } from 'rc-steps';


const Icon = ({ index, currentStep, active=true, stepCode, activeStep }) => {
    let icon = 'panorama_fish_eye';
    let extraClasses = 'lightgrey-text';

    if(index <= currentStep){
        icon = 'check_circle';
        extraClasses = 'shell-grey-text';
    }

    if(activeStep && activeStep === stepCode){
        extraClasses = 'shell-red-text';
    }

    if(index === currentStep){
        icon = 'lens';
        if(activeStep === null){
            extraClasses = 'shell-red-text';
        }
        if(active){
            extraClasses += ' step-blinker';
        }
    }

    let cssClasses = `material-icons ${extraClasses} `;

    return (
        <i className={cssClasses}>{icon}</i>
    );
};

export default class TripSteps extends Component {

    render() {
        let {steps, currentStep, activeStep, changeAction, activeTrip} = this.props;
        return (
            <div className="row margin-top-20">
                <div className={"col s12 m8 offset-m2"}>
                    <Steps labelPlacement="vertical" current={currentStep}>
                        {steps.map((step, index) => {
                            if(!this.props.activeTrip || index > currentStep || changeAction === null){
                                // Case: Closed trips or future steps
                                return (
                                    <Step key={index} title={step.name}
                                          icon={
                                              <Icon currentStep={currentStep}
                                                    index={index} active={activeTrip}
                                              />
                                          }
                                    />
                                );
                            }

                            return (
                                <Step key={index} title={step.name}
                                      onClick={() => changeAction(step)}
                                      className={"pointer"}
                                      icon={
                                          <Icon currentStep={currentStep} index={index}
                                                activeStep={activeStep} stepCode={step.code} />
                                      }
                                />
                            );
                        })}
                    </Steps>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/TripSteps.js